import shop from "@/api/priceIncrease";

// initial state
const state = {
  all: [],
  priceIncrease: {},
};

// getters
const getters = {
  priceIncrease: (state) => {
    return state.priceIncrease;
  },
};

// actions
const actions = {
  getAllPriceIncrease({ commit }) {
    shop.getPriceIncrease().then((priceIncrease) => {
      commit("getPriceIncreases", priceIncrease.data);
    });
  },
  searchPriceIncrease: async (context, priceIncrease) => {
    let d = (await shop.searchPriceIncrease(priceIncrease)).data;
    context.commit("getPriceIncreases", d);
    return d;
  },
  getPriceIncrease: async (context, id) => {
    let d = (await shop.getPriceIncreases(id)).data;
    context.commit("getPriceIncrease", d);
    return d;
  },
  postPriceIncrease: async (context, priceIncrease) => {
    const result = (await shop.postPriceIncrease(priceIncrease)).data;
    context.commit("postPriceIncrease", result);
  },
  putPriceIncrease: async (context, priceIncrease) => {
    const result = (await shop.putPriceIncrease(priceIncrease)).data;
    context.commit("putPriceIncrease", result);
  },
  deletePriceIncrease: async (context, priceIncrease) => {
    (await shop.deletePriceIncrease(priceIncrease)).data;
    context.commit("deletePriceIncrease", priceIncrease);
  },
};

// mutations
const mutations = {
  getPriceIncreases(state, priceIncrease) {
    state.all = priceIncrease;
  },
  getPriceIncrease(state, priceIncrease) {
    //state.priceIncrease = priceIncrease
    state.priceIncrease = null;
    state.priceIncrease = Object.assign({}, state.priceIncrease, priceIncrease);
  },
  postPriceIncrease(state, priceIncrease) {
    //state.priceIncrease = priceIncrease
    state.priceIncrease = null;
    state.priceIncrease = Object.assign({}, state.priceIncrease, priceIncrease);
  },
  putPriceIncrease(state, priceIncrease) {
    //state.priceIncrease = priceIncrease
    state.priceIncrease = null;
    state.priceIncrease = Object.assign({}, state.priceIncrease, priceIncrease);
  },
  deletePriceIncrease(state, priceIncrease) {
    state.all.splice(state.all.indexOf(priceIncrease), 1);
  },
  decrementPriceIncreaseInventory(state, { id }) {
    const priceIncrease = state.all.find(
      (priceIncrease) => priceIncrease.id === id
    );
    priceIncrease.inventory--;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
